import { NgModule } from '@angular/core';
import { geolocalizationService } from "@core/services/geolocalization/geolocalization.service";

@NgModule({
  providers: [geolocalizationService],
})
export class GeolocalizationModule {
  /**
   * Constructor
   */
  constructor(private _geolocalizationService: geolocalizationService) {}
}
